// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: ct9kVdatV78GHhK9QiJ54N
// Component: nzwm_0AVBn4
import * as React from "react";
import * as ph from "@plasmicapp/host";
import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts
} from "@plasmicapp/react-web";
import Sidebar from "../../Sidebar"; // plasmic-import: KsLZ7sb8Ji8/component
import TopBar from "../../TopBar"; // plasmic-import: MnkTdPJ0xv/component
import "@plasmicapp/react-web/lib/plasmic.css";
import projectcss from "./plasmic_astriusdraft.module.css"; // plasmic-import: ct9kVdatV78GHhK9QiJ54N/projectcss
import sty from "./PlasmicInvoiceInstance.module.css"; // plasmic-import: nzwm_0AVBn4/css
import Line6Icon from "./icons/PlasmicIcon__Line6"; // plasmic-import: x6cQJ36_PF/icon

export const PlasmicInvoiceInstance__VariantProps = new Array();

export const PlasmicInvoiceInstance__ArgProps = new Array();

export const defaultInvoiceInstance__Args = {};

function PlasmicInvoiceInstance__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = Object.assign({}, defaultInvoiceInstance__Args, props.args);
  const $props = args;
  const $ctx = ph.useDataEnv?.() || {};
  return (
    <React.Fragment>
      <div className={projectcss.plasmic_page_wrapper}>
        <div
          data-plasmic-name={"root"}
          data-plasmic-override={overrides.root}
          data-plasmic-root={true}
          data-plasmic-for-node={forNode}
          className={classNames(
            projectcss.all,
            projectcss.root_reset,
            projectcss.plasmic_default_styles,
            projectcss.plasmic_mixins,
            sty.root
          )}
        >
          <Sidebar
            data-plasmic-name={"sidebar"}
            data-plasmic-override={overrides.sidebar}
            className={classNames("__wab_instance", sty.sidebar)}
          />

          <div className={classNames(projectcss.all, sty.freeBox__y852M)}>
            <TopBar
              data-plasmic-name={"topBar"}
              data-plasmic-override={overrides.topBar}
              className={classNames("__wab_instance", sty.topBar)}
            />

            <div
              data-plasmic-name={"figmaPaste"}
              data-plasmic-override={overrides.figmaPaste}
              className={classNames(projectcss.all, sty.figmaPaste)}
            >
              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text___9Z79L
                )}
              >
                {"$1024.00 USD"}
              </div>

              <div
                className={classNames(
                  projectcss.all,
                  projectcss.__wab_text,
                  sty.text__hNZp8
                )}
              >
                {"Invoice Payment"}
              </div>

              <div
                data-plasmic-name={"rectangle54"}
                data-plasmic-override={overrides.rectangle54}
                className={classNames(projectcss.all, sty.rectangle54)}
              >
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__o2CVl
                  )}
                >
                  {"Paid"}
                </div>
              </div>

              <div
                data-plasmic-name={"rectangle57"}
                data-plasmic-override={overrides.rectangle57}
                className={classNames(projectcss.all, sty.rectangle57)}
              >
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__mcoBs
                  )}
                >
                  {"View Receipt"}
                </div>
              </div>

              <div
                data-plasmic-name={"rectangle58"}
                data-plasmic-override={overrides.rectangle58}
                className={classNames(projectcss.all, sty.rectangle58)}
              >
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__mmcQ8
                  )}
                >
                  {"Refund"}
                </div>
              </div>
            </div>

            <div className={classNames(projectcss.all, sty.freeBox__rWLfB)}>
              <div className={classNames(projectcss.all, sty.freeBox__u4Yoh)}>
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__nIm3Y
                  )}
                >
                  {"Date"}
                </div>

                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__zjqmz
                  )}
                >
                  {"Dec 28th, 12:25 AM"}
                </div>
              </div>

              <div
                className={classNames(projectcss.all, sty.freeBox___1ZApo)}
              />

              <div className={classNames(projectcss.all, sty.freeBox___5AoZq)}>
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__eSvgV
                  )}
                >
                  {"Customer"}
                </div>

                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__nRlGb
                  )}
                >
                  {"Nike"}
                </div>
              </div>

              <div className={classNames(projectcss.all, sty.freeBox__gIc5I)} />

              <div className={classNames(projectcss.all, sty.freeBox__bd9HL)}>
                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text___0HPdn
                  )}
                >
                  {"Payment Method"}
                </div>

                <div
                  className={classNames(
                    projectcss.all,
                    projectcss.__wab_text,
                    sty.text__yLnEq
                  )}
                >
                  {"Card"}
                </div>
              </div>
            </div>

            <div
              data-plasmic-name={"title2"}
              data-plasmic-override={overrides.title2}
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.title2
              )}
            >
              {"Edit"}
            </div>

            <div
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text__inOVa
              )}
            >
              {"Payment History"}
            </div>

            <div
              data-plasmic-name={"title"}
              data-plasmic-override={overrides.title}
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.title
              )}
            >
              {"Notes"}
            </div>

            <Line6Icon
              data-plasmic-name={"svg"}
              data-plasmic-override={overrides.svg}
              className={classNames(projectcss.all, sty.svg)}
              role={"img"}
            />

            <div
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text__fjmpy
              )}
            >
              {"December 15th, 12:25 AM"}
            </div>

            <div
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text__tLGp
              )}
            >
              {"Payment Succeded:"}
            </div>

            <div
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text__dh6NO
              )}
            >
              {"December 28th, 12:25 AM"}
            </div>

            <div
              className={classNames(
                projectcss.all,
                projectcss.__wab_text,
                sty.text___8FiFu
              )}
            >
              {"Invoice Created:"}
            </div>

            <div
              data-plasmic-name={"rectangle50"}
              data-plasmic-override={overrides.rectangle50}
              className={classNames(projectcss.all, sty.rectangle50)}
            />
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

const PlasmicDescendants = {
  root: [
    "root",
    "sidebar",
    "topBar",
    "figmaPaste",
    "rectangle54",
    "rectangle57",
    "rectangle58",
    "title2",
    "title",
    "svg",
    "rectangle50"
  ],

  sidebar: ["sidebar"],
  topBar: ["topBar"],
  figmaPaste: ["figmaPaste", "rectangle54", "rectangle57", "rectangle58"],
  rectangle54: ["rectangle54"],
  rectangle57: ["rectangle57"],
  rectangle58: ["rectangle58"],
  title2: ["title2"],
  title: ["title"],
  svg: ["svg"],
  rectangle50: ["rectangle50"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = deriveRenderOpts(props, {
      name: nodeName,
      descendantNames: [...PlasmicDescendants[nodeName]],
      internalArgPropNames: PlasmicInvoiceInstance__ArgProps,
      internalVariantPropNames: PlasmicInvoiceInstance__VariantProps
    });

    return PlasmicInvoiceInstance__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicInvoiceInstance";
  } else {
    func.displayName = `PlasmicInvoiceInstance.${nodeName}`;
  }
  return func;
}

export const PlasmicInvoiceInstance = Object.assign(
  // Top-level PlasmicInvoiceInstance renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    sidebar: makeNodeComponent("sidebar"),
    topBar: makeNodeComponent("topBar"),
    figmaPaste: makeNodeComponent("figmaPaste"),
    rectangle54: makeNodeComponent("rectangle54"),
    rectangle57: makeNodeComponent("rectangle57"),
    rectangle58: makeNodeComponent("rectangle58"),
    title2: makeNodeComponent("title2"),
    title: makeNodeComponent("title"),
    svg: makeNodeComponent("svg"),
    rectangle50: makeNodeComponent("rectangle50"),
    // Metadata about props expected for PlasmicInvoiceInstance
    internalVariantProps: PlasmicInvoiceInstance__VariantProps,
    internalArgProps: PlasmicInvoiceInstance__ArgProps
  }
);

export default PlasmicInvoiceInstance;
/* prettier-ignore-end */
